<template>
  <card-item card="item_name" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        {
          title: "Группа характеристик",
          component: () => import("./Features"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>